import './App.css';

function App() {
  return (
    <div className="HackerApp">
      <header className="HackerHeader">
        <h1 className="HackerTitle" tabIndex={0}>
          <span className="glitch" data-text="MAD CODE SKILLS">MAD CODE SKILLS</span>
        </h1>
        <div className="GifContainer" tabIndex={0}>
          <img src={process.env.PUBLIC_URL + '/cool_hackers.gif'} alt="Hacker GIF" className="HackerGif" />
        </div>
        <nav className="HackerNav">
          <a className="HackerLink" href="#" tabIndex={0}>Sign up</a>
          <a className="HackerLink" href="#" tabIndex={0}>Sign in</a>
          <a className="HackerLink" href="#" tabIndex={0}>Settings</a>
        </nav>
        <p className="HackerFooter" tabIndex={0}>
          Edit <code>src/App.js</code> and save to hack the planet.
        </p>
      </header>
    </div>
  );
}

export default App;
